import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/vwb-demo/$')({
  component: JourneysLegacyRoute,
});
